/**
 * SearchKeyboardContainer component.
 */
import styled from 'styled-components';
import { TRANSITION } from '@shared/types/constants/animations';

/**
 * Styled search keyboard container.
 */
const SearchKeyboardContainer = styled.div<React.CSSProperties>`
  transition: ${TRANSITION.SEARCH_KEYBOARD_SCROLL};
`;

export default SearchKeyboardContainer;
